import { ProgressStatusEnum } from "../enums/progress-status.enum";
import { BaseCrudProxy, EmptyBaseCrudProxy } from "./base-crud.proxy";

 export interface UserProgressProxy extends BaseCrudProxy {

  //#region Public Properties

  userId: string;

  courseId: string;

  moduleId?: string;

  lessonId: string | null;

  quizId: string | null;

  status: ProgressStatusEnum;

  grade?: number;

  organizationId?: string;

  videoTime?: number;

  totalTime?: number;

  //#endregion

}

export const  EmptyUserProgress: UserProgressProxy = {
  ...EmptyBaseCrudProxy,
  userId: '',
  courseId: '',
  moduleId: '',
  lessonId: null,
  quizId: null,
  status: ProgressStatusEnum.LESSON,
  grade: undefined,
  organizationId: '',
  videoTime: 0,
  totalTime: 0,
}